'use client';

import CmsBlockGroup from '@/components/CmsBlock';
import useIsMobile from '@/hooks/use-is-mobile';
import classes from './tourismGivernyPage.module.css';

export const TourismGivernyPage = () => {
  const isMobile = useIsMobile();

  return (
    <div className={classes.tourismgiverny}>
      <CmsBlockGroup
        classes={{
          root: classes.content,
        }}
        identifiers={isMobile ? 'tourismgiverny_m' : 'tourismgiverny'}
      />
    </div>
  );
};

export default TourismGivernyPage;
